import React from "react";

const SmsUs = ({ category }) => {
  return (
    <div className="col-md-4 my-3">
      <div className="card h-100 no-border">
        <div className="w-100 text-center icon">
          <img className="p-2 chat-img" src={category.image} />
        </div>
        <div className="card-body text-center pb-0 main-countainer">
          <h4 className="font-weight-bold main-title ">{category.title}</h4>
          <p className="font-weight-normal px-md-2">{category.desc}</p>
          <br />
          <h6 className="sub-title">Retail Store/Corporate/Grocery Delivery</h6>
          <h6 className="sub-title">& Pick up</h6>
          <br />
          <p className="font-weight-normal px-md-2">844-549-1193</p>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};


export default SmsUs ;
